import type { LearnPracticalContent } from "../practicalContent.js";

export const foodLabelsContent: LearnPracticalContent = {
  th: {
    notice: [
      "ฉลากอาหารช่วยบอกส่วนประกอบ สารก่อภูมิแพ้ วันหมดอายุ และวิธีเก็บ",
      "คำว่าอาจมีหรือผลิตร่วมกับช่วยบอกความเสี่ยงจากการปนเปื้อนข้าม",
      "สูตร ส่วนประกอบ หรือสถานที่ผลิตอาจเปลี่ยนได้ แม้ชื่อและภาพด้านหน้าจะเหมือนเดิม",
      "ข้อความโฆษณาด้านหน้าซอง เช่น natural หรือ healthy ไม่ได้แทนการอ่านส่วนประกอบ ปริมาณต่อหน่วยบริโภค และคำเตือน",
    ],
    prepare: [
      "รู้ชื่อสารก่อภูมิแพ้ของตนเอง รวมทั้งชื่ออื่นที่อาจใช้บนฉลาก",
      "ตรวจฉลากใหม่ทุกครั้ง แม้เคยซื้อผลิตภัณฑ์เดิม",
      "มีแผนรับมืออาการแพ้ที่ผู้ประกอบวิชาชีพให้ไว้ และบอกคนที่เตรียมอาหารว่าต้องหลีกเลี่ยงอะไร",
      "เมื่อสั่งอาหารเดลิเวอรีหรือกินนอกบ้าน ให้แจ้งสารที่ต้องหลีกเลี่ยงอย่างชัดเจน แต่ถือว่าคำตอบของร้านไม่แทนฉลากหรือคำแนะนำทางการแพทย์",
    ],
    during: [
      "อ่านส่วนประกอบ คำเตือนสารก่อภูมิแพ้ วันหมดอายุ และสภาพบรรจุภัณฑ์ก่อนกิน",
      "เมื่อไม่แน่ใจ ให้ถามผู้ผลิต ผู้ขาย หรือผู้ประกอบวิชาชีพก่อนบริโภค",
      "แยกอาหารและอุปกรณ์ที่อาจปนเปื้อนข้ามเมื่อเตรียมอาหารให้ผู้แพ้อาหาร",
      "อ่านวิธีเก็บและวิธีเตรียมบนฉลาก แล้วอย่าใช้ผลิตภัณฑ์ที่ซองบวม รั่ว หรือซีลเสียหาย",
    ],
    avoid: [
      "อย่าคาดเดาจากชื่ออาหาร รูปภาพ หรือประสบการณ์ครั้งก่อน",
      "อย่ากินอาหารที่ไม่มีฉลากชัดเจนเมื่อจำเป็นต้องหลีกเลี่ยงสารก่อภูมิแพ้",
      "อย่าเขี่ยส่วนผสมที่แพ้ออกแล้วกินส่วนที่เหลือ เพราะสารก่อภูมิแพ้อาจปนอยู่ทั่วอาหาร",
      "อย่าแชร์ช้อน หลอด ภาชนะ หรือมือที่สัมผัสอาหารกับผู้ที่ต้องหลีกเลี่ยงสารก่อภูมิแพ้โดยไม่ล้างให้เหมาะสม",
    ],
    help: [
      "หากเกิดอาการแพ้ ให้หยุดกินและทำตามแผนที่แพทย์ให้ไว้",
      "อาการหายใจลำบาก หมดสติ หรืออาการรุนแรงต้องขอความช่วยเหลือฉุกเฉิน",
      "ขอคำแนะนำจากผู้ประกอบวิชาชีพหากอาการเกิดซ้ำ ฉลากไม่ชัด หรือไม่แน่ใจว่าสารนั้นใช้ชื่อใดบนฉลาก",
      "เก็บซองหรือถ่ายภาพฉลากไว้เมื่อมีอาการหลังรับประทาน เพื่อให้ผู้ประกอบวิชาชีพช่วยประเมินได้โดยไม่ต้องเดาสูตรอาหาร",
    ],
    example:
      "ซื้อขนมยี่ห้อเดิมแต่ซองเปลี่ยน: อ่านส่วนประกอบและคำเตือนสารก่อภูมิแพ้ใหม่ทั้งหมด หากไม่ชัดเจนและต้องหลีกเลี่ยงสารนั้น อย่าคาดเดาว่าปลอดภัย",
    cautions: [
      {
        title: "ความดันสูงหรือโรคหัวใจ: ดูโซเดียม ไม่ใช่แค่รสเค็ม",
        text: "อาหารแปรรูป อาหารสำเร็จรูป และอาหารร้านอาจมีโซเดียมสูงแม้ไม่รู้สึกเค็มเท่ากัน เปรียบเทียบโซเดียมต่อหนึ่งหน่วยบริโภคบนฉลาก และใช้เป้าหมายที่ทีมรักษาของคุณให้ไว้แทนการตัดอาหารทั้งกลุ่มเอง",
      },
      {
        title: "โรคไต: อย่าเปลี่ยนเป็นเกลือโพแทสเซียมเอง",
        text: "ผู้มีโรคไตอาจต้องปรับโซเดียม โพแทสเซียม ฟอสฟอรัส หรือปริมาณน้ำตามระยะโรคและผลตรวจ สารทดแทนเกลือและอาหารบรรจุภัณฑ์บางชนิดมีโพแทสเซียม จึงควรถามทีมรักษาหรือนักกำหนดอาหารก่อนเปลี่ยน",
      },
      {
        title: "เกาต์หรือเคยเป็นนิ่ว: ไม่ใช้รายการห้ามกินชุดเดียว",
        text: "อาหารที่เหมาะสมขึ้นกับการวินิจฉัย ชนิดของนิ่ว ยา และโรคอื่นร่วมกัน อย่าเริ่มงดอาหารหลายอย่างหรือใช้ผลิตภัณฑ์ “ดีท็อกซ์” แทนการรักษา ให้ขอแผนรายบุคคลจากแพทย์หรือนักกำหนดอาหาร",
      },
    ],
    situations: [
      {
        title: "ซื้ออาหารออนไลน์",
        text: "รูปหน้าร้านและเมนูอาจไม่บอกส่วนประกอบครบ หากต้องหลีกเลี่ยงสารก่อภูมิแพ้ ให้ถามข้อมูลที่ตรวจสอบได้และไม่เสี่ยงเมื่อคำตอบไม่ชัด",
      },
      {
        title: "ทำอาหารร่วมกัน",
        text: "ใช้ภาชนะและอุปกรณ์แยกสำหรับผู้แพ้อาหาร และอ่านฉลากซอส เครื่องปรุง และขนมทุกชิ้น ไม่ดูเพียงวัตถุดิบหลัก",
      },
      {
        title: "ตู้เย็นที่ทำงาน",
        text: "ติดชื่ออาหารและอย่าใช้ช้อนหรือกล่องร่วมกันโดยไม่ล้าง โดยเฉพาะเมื่อมีคนต้องหลีกเลี่ยงสารก่อภูมิแพ้",
      },
    ],
    checklist: [
      "รู้ชื่อสารที่ต้องหลีกเลี่ยง",
      "อ่านส่วนประกอบทุกครั้ง",
      "ดูคำเตือนการปนเปื้อนข้าม",
      "ตรวจวันหมดอายุและบรรจุภัณฑ์",
      "ถามก่อนกินเมื่อข้อมูลไม่ชัด",
      "อ่านวิธีเก็บและสภาพซอง",
      "แยกอุปกรณ์เมื่อมีผู้แพ้อาหาร",
    ],
  },
  en: {
    notice: [
      "Food labels identify ingredients, allergens, expiry, and storage instructions.",
      "May contain or shared-facility statements can indicate cross-contact risk.",
      "Recipes, ingredients, or production sites can change even when the name and front image look familiar.",
      "Front-of-pack marketing such as natural or healthy does not replace the ingredient list, serving size, and warnings.",
    ],
    prepare: [
      "Know your allergens and the alternative names that may appear on labels.",
      "Recheck the label every time, even for a product bought before.",
      "Keep the reaction plan provided by your clinician and tell food preparers what must be avoided.",
      "For delivery or restaurant food, state the allergen clearly, but do not treat a restaurant reply as a substitute for a label or medical advice.",
    ],
    during: [
      "Read ingredients, allergen warnings, expiry, and package condition before eating.",
      "If uncertain, ask the producer, seller, or a health professional before consuming it.",
      "Separate food and utensils that could cause cross-contact when preparing food for someone with an allergy.",
      "Follow storage and preparation directions, and do not use a pack that is swollen, leaking, or has a broken seal.",
    ],
    avoid: [
      "Do not guess from the food name, picture, or a previous experience.",
      "Avoid unlabelled food when you need to exclude a specific allergen.",
      "Do not remove a visible allergen and eat the rest; allergen may remain throughout the food.",
      "Do not share spoons, straws, containers, or hands that contacted food with someone avoiding an allergen unless appropriately cleaned.",
    ],
    help: [
      "If a reaction occurs, stop eating and follow the plan provided by your clinician.",
      "Breathing difficulty, unconsciousness, or a severe reaction requires emergency help.",
      "Ask a health professional about repeated symptoms, unclear labels, or unfamiliar names for an allergen.",
      "Keep the pack or a photo of its label after a reaction so a health professional can assess it without guessing the recipe.",
    ],
    example:
      "A familiar snack comes in a redesigned pack: reread the ingredients and allergen warning. If the information is unclear and you must avoid an allergen, do not assume it is safe.",
    cautions: [
      {
        title: "High blood pressure or heart disease: check sodium, not only saltiness",
        text: "Processed, ready-made, and restaurant foods can be high in sodium even when they do not taste equally salty. Compare sodium per serving on labels, and use the target set by your care team rather than removing whole food groups on your own.",
      },
      {
        title: "Kidney disease: do not switch to potassium salt substitutes on your own",
        text: "People with kidney disease may need individual changes to sodium, potassium, phosphorus, or fluids based on stage and test results. Salt substitutes and some packaged foods can contain potassium, so ask your care team or dietitian before changing products.",
      },
      {
        title: "Gout or a history of kidney stones: there is no single banned-food list",
        text: "The suitable food plan depends on the diagnosis, stone type, medicines, and other conditions. Do not cut out many foods or substitute “detox” products for treatment; ask a doctor or dietitian for an individual plan.",
      },
    ],
    situations: [
      {
        title: "Online food order",
        text: "A shop image or menu may not list every ingredient. If you must avoid an allergen, ask for checkable information and do not take the risk when the answer is unclear.",
      },
      {
        title: "Shared cooking",
        text: "Use separate containers and utensils for an allergy-sensitive meal, and read labels on sauces, seasonings, and snacks—not only the main ingredient.",
      },
      {
        title: "Work fridge",
        text: "Label food and do not share spoons or containers without washing, especially when someone must avoid an allergen.",
      },
    ],
    checklist: [
      "Know the allergen names",
      "Read every ingredient list",
      "Check cross-contact warnings",
      "Check expiry and packaging",
      "Ask before eating when unclear",
      "Check storage directions and package condition",
      "Separate utensils for an allergy-sensitive meal",
    ],
  },
};
